import andamento from "@/router/andamento";

export default ({ instance }) => {
	return {
		//Dashboard

		ExportardadosCompletosExcelAndamento(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "homeandamento/exportar-tabela-excel",
				data: filtro,
			});
		},

		relatorioMesAnoPorFiltroAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/mes-ano-filtro",
				data: filtro,
			});
		},

		relatorioClassificacaoPorFiltroAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/classificacao-filtro",
				data: filtro,
			});
		},

		relatorioGrupoOperacionalPorFiltroAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/grupo-operacional-filtro",
				data: filtro,
			});
		},

		buscarSubGrupoAndamento(grupoOperacional) {
			return instance({
				method: "get",
				url: "homeandamento/" + grupoOperacional,
			});
		},

		relatorioPorJusticaAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/justica",
				data: filtro,
			});
		},

		relatorioPorMesAnoAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/mes-ano",
				data: filtro,
			});
		},

		relatorioPorUfAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/uf",
				data: filtro,
			});
		},

		relatorioPorClassificacaoAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/classificacao",
				data: filtro,
			});
		},

		//Processos Monitorados
		consultarProcessosMonitoradosAndamento(filtro) {
			return instance({
				method: "post",
				url: "processosmonitoradosandamento/processos-monitorados",
				data: filtro,
			});
		},

		exportarProcessosMonitoradosAndamento(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "processosmonitoradosandamento/exportar-processos-monitorados",
				data: filtro,
			});
		},

		carregarPlanilhaNovosProcessosMonitorados(grupoOperacional, grupoPesquisa, file) {
			const formData = new FormData();
			formData.append("grupoOperacional", grupoOperacional);
			formData.append("grupoPesquisa", grupoPesquisa);
			formData.append("arquivoExcel", file);

			return instance({
				method: "post",
				url: "processosmonitoradosandamento/receber-processos-excel",
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
			});
		},

		salvarProcessosMonitorados(filtro) {
			return instance({
				method: "post",
				url: "processosmonitoradosandamento/salvar-processos-excel",
				data: filtro,
			});
		},

		consultarAlteracaoMonitoramentoPendente(filtro) {
			return instance({
				method: "post",
				url:
					"processosmonitoradosandamento/importacao-pendente",
				data: filtro,
			});
		},

		consultarListaAlteracaoMonitoramentoPendente(filtro) {
			return instance({
				method: "post",
				url: "processosmonitoradosandamento/lista-importacao-pendente",
				data: filtro,
			});
		},

		excluirMonitoramentoPendente(filtro) {
			return instance({
				method: "post",
				url:"processosmonitoradosandamento/excluir-importacao-pendente",
				data: filtro,
			});
		},

		consultarSePossuiCampoAdicional(grupoOperacional) {
			return instance({
				method: "get",
				url:
					"processosmonitoradosandamento/consultar-campo-adicional/" +
					grupoOperacional,
			});
		},
		andamentosExportarErroProcessosExcel(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "processosmonitoradosandamento/exportar-processos-erros-excel",
				data: filtro,
			});
		},

		//Andamentos
		andamentosProcessos(filtros) {
			return instance({
				method: "post",
				url: "andamentos/processos",
				data: filtros,
			});
		},
		andamentosExportarProcessosExcel(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "andamentos/exportar-processos-excel",
				data: filtro,
			});
		},
		andamentosExportarProcessosJson(filtro) {
			return instance({
				method: "post",
				url: "andamentos/exportar-processos-json",
				data: filtro,
			});
		},
		andamentosExportarProcessosXml(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "andamentos/exportar-processos-xml",
				data: filtro,
			});
		},
		andamentosExportarProcessosDocx(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "andamentos/exportar-processos-docx",
				data: filtro,
			});
		},
		andamentosDetalheAndamento(codigo) {
			return instance({
				method: "post",
				url: "andamentos/detalhe-andamento",
				data: codigo,
			});
		},

		andamentosConsultarProcessosPorDia(filtro) {
			return instance({
				method: "post",
				url: "andamentos/processos-por-dia",
				data: filtro,
			});
		},
		andamentosProcessosUnicos(codigo) {
			return instance({
				method: "post",
				url: "andamentos/processos-unicos",
				data: codigo,
			});
		},
		andamentosHistoricoAndamento(codigo) {
			return instance({
				method: "post",
				url: "andamentos/historico-andamento",
				data: codigo,
			});
		},
		consultarListaClassificacoes(grupoOperacional) {
			return instance({
				method: "get",
				url: "andamentos/lista-classificacoes/" + grupoOperacional,
			});
		},
		consultarDadosCapaPorNpu(filtro) {
			return instance({
				method: "post",
				url: "andamentos/dados-capa-npu",
				data: filtro,
			});
		},
		consultarGrupoPesquisa(grupoOperacional) {
			return instance({
				method: "get",
				url: "andamentos/consultar-grupo-pesquisa/" + grupoOperacional,
			});
		},
		andamentosDownloadPlanilha(filtro) {
			return instance({
				responseType: "blob",
				method: "post",
				url: "andamentos/download-planilha",
				data: filtro,
			});
		},
		andamentosConsultarAtividadeRecente(filtro) {
			return instance({
				method: "post",
				url: "andamentos/atividade-recente",
				data: filtro,
			});
		},
		relatorioPorMesAnoHomeAndamento(filtro) {
			return instance({
				method: "post",
				url: "homeandamento/mes-ano-home",
				data: filtro,
			});
		},
	};
};
